import * as actions from './actions';
import * as constants from './constants';
import * as D from './deps';
import reducer from './reducer';
import watchers from './sagas/watchers';
import * as selectors from './selectors';
import * as utils from './utils';

export default D.createDomainModule({
  name: constants.DOMAIN_NAME,
  actions,
  constants,
  persisted: true,
  reducer,
  selectors,
  utils,
  watchers,
  onLoad(store) {
    window.addEventListener('unload', () => {
      if (D.getInDomain('playback.utils.isAudioPlaying', false)(store.getState())) {
        store.dispatch(actions.pauseSource({ onUnload: true }));
      }
    });
  },
});
